<div class="box">
  <form [formGroup]="formCompanyQuery">
    <div class="row m-tb-15">
      <div class="col-6">
        <mat-form-field class="full-width">
          <mat-label>Companies</mat-label>
          <mat-select formControlName="companyId" (selectionChange)="companySelect($event)">
            @for (companies of companiesList; track companies) {
              <mat-option [value]="companies._id">
                {{ companies.name }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>* Madatory Field</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-6">
        <mat-form-field class="full-width">
          <mat-label>Division</mat-label>
          <mat-select formControlName="divisionId" (selectionChange)="getPlayersByDivisions()" multiple>
            @for (division of divisionList; track division) {
              <mat-option [value]="division._id">
                {{ division.name }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>* Madatory Field</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<!-- <div class="sticky-0">
<h5 class="fw-400">Players</h5>
<h6 class="badge badge-success badge-users">
  <span class="ft-users"></span> {{ totalPlayers }}
</h6>
</div> -->
<!-- <div class="search-holder">
<form [formGroup]="searchForm" class="example-form">
  <mat-form-field
    class="example-full-width"
    style="float: right"
    appearance="outline"
    >
    <mat-label>Search</mat-label>
    <input
      type="search"
      matInput
      formControlName="searchCtrl"
      #message
      maxlength="25"
      placeholder="Search"
      />
    </mat-form-field>
  </form>
</div> -->

<ng-template #tableTools>
  <h6 class="badge badge-success badge-users" style="margin-right: 15px; margin-top: 10px;">
    <span class="ft-users"></span> {{ totalPlayers }}
  </h6>
</ng-template>

<ng-template #cellTemplate let-selected="item">
  <span>{{selected?.divisionId?.companyId?.name}}</span>
</ng-template>

<ng-template #cellTemplate1 let-selected="item">
  <span>{{ selected?.divisionId?.name }}</span>
</ng-template>

<ng-template #actions let-selected="item">
  <button type="button" class="btn btn-raised btn-danger btn-sm btn-action mlr-2" (click)="
    $event.stopPropagation();
    deletePlayer({ email: selected.email, _id: selected._id })
    ">
    <span class="fa fa-trash"></span> Remove
  </button>
  <button type="button" class="btn btn-raised btn-success btn-sm btn-action mlr-2"
    (click)="$event.stopPropagation(); viewPlayerDetails(selected._id)">
    <span class="fa fa-eye"></span> view
  </button>
</ng-template>

<app-datatable [columns]="columns" [data]="players" [tableTools]="tableTools" [totalCount]="players.length"
  paginationPosition="top" showIndexColumn="true" (refreshEvent)="refresh()" name="Players">
</app-datatable>

<!-- <table class="table">
<thead>
  <tr>
    <th>#</th>
    <th>First Name</th>
    <th>Last Name</th>
    <th>Email</th>
    <th>Company</th>
    <th>Division</th>
    <th>Login Count</th>
    <th>Actions</th>
  </tr>
</thead>
<tbody>
  <tr *ngIf="players && players.length <= 0">
    <td></td>
    <td>NO DATA FOUND</td>
  </tr>
  <tr
    *ngFor="let player of players; let i = index"
    (click)="viewPlayerDetails(player._id)"
    style="cursor: pointer"
    >
    <td>
      <strong>{{ i + 1 }}</strong>
    </td>

    <td>
      <strong>{{ player?.firstName || 'NA' }}</strong>
    </td>
    <td>
      <strong>{{ player?.lastName || 'NA' }}</strong>
    </td>
    <td>
      <strong>{{ player.email }}</strong>
    </td>
    <td>
      <strong>{{ player?.divisionId?.companyId?.name || 'NA' }}</strong>
    </td>
    <td>
      <strong>{{ player?.divisionId?.name || 'NA' }}</strong>
    </td>
    <td>
      <strong>{{ player.loginCount }}</strong>
    </td>

    <td nowrap>
      <button
        type="button"
        class="btn btn-raised btn-danger btn-sm btn-action mlr-2"
        (click)="
        $event.stopPropagation();
        deletePlayer({ email: player.email, _id: player._id })
        "
        >
        <span class="fa fa-trash"></span> Remove
      </button>
      <button
        type="button"
        class="btn btn-raised btn-success btn-sm btn-action mlr-2"
        (click)="$event.stopPropagation(); viewPlayerDetails(player._id)"
        >
        <span class="fa fa-eye"></span> view
      </button>
    </td>
  </tr>
</tbody>
</table> -->

<!-- Do Not Remove ngIf condition, the page number autoinitialises to 1 otherwise --workaround-fix -->
<!-- <div *ngIf="totalPlayers" class="justify-content-center">
<ngb-pagination
  [(page)]="page"
  [(collectionSize)]="totalPlayers"
  [maxSize]="20"
  [pageSize]="pageSize"
  (pageChange)="loadPage($event)"
  >
</ngb-pagination>
</div> -->